/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom'
import React, { useContext } from 'react'
import { Button } from "react-bootstrap";
import {
  Container,
  Estado,
  Row,
  SmileIcon,
  Card,
  CheckIcon,
  Price,
  ButtonCard,
  Color,
  Beneficios,
  ShildeIcon,
  CopaIcon,
} from "./styles";
import AddItem from '../../Carrito/AddItem'
import { AddAndBuy } from "../../Carrito/AddAndBuy";
import './ProductoVenta.css'
import { cartContext } from '../../Context/CartContext';
import { marcasContext } from '../../Context/MarcasContext';
import { useTranslation } from 'react-i18next';

const ProductoVenta = ({ datos: marca }) => {
  const pais = process.env.REACT_APP_COUNTRY

  const navigate = useNavigate();
  const { cartLocal } = useContext(cartContext);
  const { codigoMarca } = useContext(marcasContext);
  const findBrand = codigoMarca.find(item => item.Descripcion === marca.Marca)

  const itemInCart = cartLocal.length === 0 ? undefined : cartLocal.find(item => item.Alias === marca.Alias);

  const [t] = useTranslation("global")

  const formatNumber = (number) => {
    // Convierto a num
    const num = typeof number === 'number' ? number : parseFloat(number);
    
    // Verifico si es valido
    if (isNaN(num)) return '0,00';
    
    // Formato con separadores de miles y decimales
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  return (
    <Container>
      <Estado>{t("producto.nuevo-destacado")}</Estado>
      <div>
        <Row>
          <h1>{marca.Nombre}</h1>
          <SmileIcon />
        </Row>
        <Price>
          {
            marca.Stock === 0
              ? <span style={{ fontSize: "1.5rem", color: "#555", fontWeight: "500" }}>CONSULTE VALOR AL PM</span>
              : (marca.Precio ? marca.Moneda_Signo + " " + formatNumber(marca.Precio) : <h4>{t("producto.inicie-sesion")}</h4>)
          }
        </Price>

        <Card>
          {!marca.Precio && <CheckIcon />}
          <div>
            {marca.Precio && <span className="detalleIva"><p><b>* </b>{t("producto.iva-no-incluido")} {pais === "PA" ? "ITBMS" : "IVA"}</p></span>}


            {pais === "ARG" && marca.Precio && (
                ["MONITOR", "PANTALLA", "DVR", "TELEVISOR", "Galaxy"].some(palabra => marca.Nombre?.includes(palabra)) && (
                  <span className="detalleIva">
                    <p><b>* </b>{t("producto.imp-no-incluido")}</p>
                  </span>
                )
            )}
            <span className="title">{marca.Marca} </span>
            <span className="detalle"><p><b>{t("rma.garantia")}: </b> {t("producto.este-producto-garantia")} {marca.Garantia_meses} {t("rma.meses")}</p></span>
            <span className="more"><p><b>Stock: </b> {marca.Precio === undefined ? " " : marca.Stock + " unidades"}</p></span>
          </div>
        </Card>
        <Color>
          <p><b>SKU:</b> {marca.Alias}</p>
        </Color>
        <Color>
          <p><b>PARTE FABRICANTE:</b> {marca.Parte_fabricante}</p>
        </Color>
        <Color>
          <p><b>PM:</b> {marca.Produc_manager != null ? marca.Produc_manager : "Consulte al staff"}</p>
        </Color>

        <ButtonCard id="buttonCard">
          {marca.Stock === 0
            ? <Button variant="danger" onClick={() => window.open('https://www.solutionbox.com.ar/contacto', '_blank')}>Consulte al PM</Button>
            : marca.Precio === undefined
              ? <Button variant="dark" onClick={() => navigate('/login')}>{t("login.iniciar-sesion")}</Button>
              : itemInCart
                ? ""
                : <AddAndBuy producto={marca} />
          }
          {marca.Precio === undefined ? '' : <AddItem producto={marca} />}
          {itemInCart ? <Button variant='secondary' className='mt-2' onClick={() => navigate('/marcas/' + findBrand.Codigo)}>{t("producto.seguir-comprando")} {marca.Marca}</Button> : ""}
        </ButtonCard>
        <Beneficios>
          <li>
            <ShildeIcon />
            <p>
              {pais === "CL"
                ? t("producto.compra-chile")
                : t("producto.compra")}  {" "}
              <span>
                {t("producto.manera-segura")}
              </span>
            </p>
          </li>
          <li>
            <CopaIcon />
            <p>
              Solution Box {" "}
              <span>{t("producto.productos-calidad")}.</span>
            </p>
          </li>
        </Beneficios>
      </div>

    </Container>
  );
};

export default ProductoVenta;